import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import BannerService from "../services/BannerService";

export const BannerContext = createContext("BannerContext");

const BannerContextProvider = ({ children }) => {
	const [bannerList, setBannerList] = useState([]);
	const [loadingBannerList, setLoadingBannerList] = useState(false);
	const [bannerListErrorMsg, setBannerListErrorMsg] = useState("");

	const getBannerList = async (params) => {
		setLoadingBannerList(true);
		setBannerListErrorMsg("");
		try {
			const response = await BannerService.getBannerList(params);
			setBannerList(response.data);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setBannerListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingBannerList(false);
		}
	};

	return (
		<BannerContext.Provider
			value={{
				getBannerList,
				bannerList,
				loadingBannerList,
				bannerListErrorMsg,
			}}
		>
			{children}
		</BannerContext.Provider>
	);
};

export default BannerContextProvider;
